export default __webpack_public_path__ + "static/media/image.c-t-global-consultants-pvt-ltd.107a589b.png";